// extracted by mini-css-extract-plugin
export default {"button":"Chevron_button__szl-W","marginRight":"Chevron_marginRight__EJJ66"};